import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, ListItem } from '@mui/material';
import { useContextSafe } from '@utils/useContextSafe';
import { useRemoveFileAttachmentMutation } from '../../../../../../gql';
import { getTenantIdentifier } from '../../../../../../utils/getTenantIdentifier';
import { DocumentFileNameAndIcon } from '../../../../../documents/components/DocumentFilenameAndIcon';
import { FormFillerContext } from '../../FormFillerContextProvider';
import { FormAttachment } from '../../types';

interface Props {
  fieldId: number,
  formAttachment: FormAttachment,
  canDelete?: boolean;
  onDeleted: () => void;
}

export const FileAttachmentListItem: React.FC<Props> = ({ fieldId, formAttachment, canDelete, onDeleted }) => {
  const { submissionId } = useContextSafe(FormFillerContext);

  const { mutateAsync: deleteAttachment, isPending: deletingAttachment } = useRemoveFileAttachmentMutation();


  const onDeleteAttachment = async (attachmentId: number) => {
    await deleteAttachment({
        input: {
          attachmentId,
          fieldId,
          submissionId
        }
      });

    onDeleted();
  };

  return (
    <ListItem disablePadding sx={{ border: t => `1px solid ${t.palette.divider}` }}>
      <DocumentFileNameAndIcon
        fileName={formAttachment.fileName}
        downloadLink={`/${getTenantIdentifier()}/api/Form/Submission/${submissionId}/Attachments/${formAttachment.id}`}
        actionButton={canDelete && (
          <IconButton
            disabled={deletingAttachment}
            onClick={() => onDeleteAttachment(formAttachment.id)}
          >
            {deletingAttachment ? <CircularProgress size={24} /> : <DeleteIcon />}
          </IconButton>
        )}
      />
    </ListItem>
  );
}